function normalizeFilterValue(value: unknown): string {
  return String(value ?? "").trim().toLowerCase();
}

export function matchesScopedFilter(
  values: unknown[],
  query: string | null | undefined,
): boolean {
  const normalizedQuery = normalizeFilterValue(query);
  if (!normalizedQuery) return true;
  return values.some((value) => normalizeFilterValue(value).includes(normalizedQuery));
}

export function parseDateQueryParam(
  value: string | null | undefined,
  endOfDay = false,
): number | null {
  const normalized = String(value ?? "").trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return null;
  const timeSuffix = endOfDay ? "T23:59:59.999Z" : "T00:00:00.000Z";
  const parsed = Date.parse(`${normalized}${timeSuffix}`);
  return Number.isFinite(parsed) ? parsed : null;
}
